var _defs, _g, _path, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotorRouting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.9 132.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 158.47,
    cy: 129.72,
    rx: 8.94,
    ry: 2.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m158.47,63.8c-11.84,0-21.43,9.59-21.43,21.43,0,19,21.43,40.26,21.43,40.26,0,0,21.43-21.26,21.43-40.26,0-11.84-9.6-21.43-21.43-21.43Zm0,36.05c-8.08,0-14.62-6.55-14.62-14.62s6.54-14.62,14.62-14.62,14.62,6.54,14.62,14.62-6.55,14.62-14.62,14.62Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m132.25,130.04c0,1.3-.94,2.25-2.23,2.25H46.68c-3.83,0-7.55-.51-11.05-1.51-3.4-.98-6.46-2.37-9.09-4.15-2.69-1.82-4.81-3.96-6.31-6.35-1.62-2.59-2.44-5.38-2.44-8.28s.82-5.68,2.44-8.28c1.5-2.39,3.62-4.52,6.31-6.34,2.64-1.78,5.7-3.18,9.1-4.15,3.5-1.01,7.21-1.51,11.04-1.51h62.81c5.02,0,9.72-1.31,13.24-3.69,3.27-2.22,5.07-5.04,5.07-7.95s-1.81-5.74-5.07-7.95c-3.52-2.38-8.22-3.69-13.24-3.69H43.33c-1.29,0-2.22-.95-2.22-2.25s.93-2.25,2.22-2.25h66.15c5.95,0,11.57,1.58,15.81,4.44,4.48,3.04,6.95,7.19,6.95,11.7s-2.47,8.66-6.95,11.69c-4.24,2.87-9.86,4.45-15.81,4.45h-62.81c-6.66,0-12.9,1.74-17.57,4.9-4.44,3-6.87,6.86-6.87,10.88s2.44,7.89,6.87,10.88c4.67,3.17,10.91,4.91,17.57,4.91h83.34c1.29,0,2.23.94,2.23,2.25Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30.37,65.92c0,1.5-4,2.71-8.94,2.71s-8.93-1.21-8.93-2.71,4-2.71,8.93-2.71,8.94,1.21,8.94,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.43,0C9.6,0,0,9.6,0,21.43c0,19.01,21.43,40.26,21.43,40.26,0,0,21.43-21.25,21.43-40.26C42.86,9.6,33.27,0,21.43,0Zm0,36.05c-8.07,0-14.62-6.55-14.62-14.62s6.55-14.62,14.62-14.62,14.62,6.55,14.62,14.62-6.54,14.62-14.62,14.62Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorRouting);
export default __webpack_public_path__ + "static/media/MotorRouting.0e4ca9cf332cbb7a05bbaa1816e37494.svg";
export { ForwardRef as ReactComponent };